import { c as _c } from "react/compiler-runtime";
import { Button } from '@/frontend/design-system/actions/Button';
import { cn } from '@/frontend/utils';
type SingleViewEditorProps = {
  editorReady: boolean;
  showPreview: boolean;
  handleToggleView: () => void;
  EditorSection: React.ReactNode;
  PreviewSection: React.ReactNode;
  height?: number;
  children?: React.ReactNode;
};
export const SingleViewEditor = t0 => {
  const $ = _c(31);
  const {
    editorReady,
    showPreview,
    handleToggleView,
    EditorSection,
    PreviewSection,
    height,
    children
  } = t0;
  const t1 = `${height}rem`;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      minHeight: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = !editorReady && "hidden";
  let t4;
  if ($[2] !== t3) {
    t4 = cn(t3, "bg-backgroundSecondary border-borderPrimary h-full flex-1 rounded-lg border");
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = `${height}rem`;
  let t6;
  if ($[4] !== t5) {
    t6 = {
      height: t5
    };
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = showPreview ? "Wr\xF3\u0107 do edycji" : "Podgl\u0105d";
  let t8;
  if ($[6] !== handleToggleView || $[7] !== t7) {
    t8 = <section className="flex h-12 items-center justify-end rounded-t-lg border-borderPrimary border-b bg-backgroundTertiary px-3"><Button size="sm" onClick={handleToggleView}>{t7}</Button></section>;
    $[6] = handleToggleView;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = showPreview && "hidden";
  let t10;
  if ($[9] !== t9) {
    t10 = cn(t9, "h-full bg-backgroundSecondary rounded-lg");
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== EditorSection || $[12] !== t10) {
    t11 = <div className={t10}>{EditorSection}</div>;
    $[11] = EditorSection;
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  const t12 = !showPreview && "hidden";
  let t13;
  if ($[14] !== t12) {
    t13 = cn(t12, "h-full bg-backgroundSecondary rounded-lg");
    $[14] = t12;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== PreviewSection || $[17] !== t13) {
    t14 = <div className={t13}>{PreviewSection}</div>;
    $[16] = PreviewSection;
    $[17] = t13;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== t11 || $[20] !== t14) {
    t15 = <div className="h-[calc(100%-3rem)]">{t11}{t14}</div>;
    $[19] = t11;
    $[20] = t14;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== t15 || $[23] !== t4 || $[24] !== t6 || $[25] !== t8) {
    t16 = <div className={t4} style={t6} suppressHydrationWarning={true}>{t8}{t15}</div>;
    $[22] = t15;
    $[23] = t4;
    $[24] = t6;
    $[25] = t8;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== children || $[28] !== t16 || $[29] !== t2) {
    t17 = <main className="w-full space-y-2" style={t2} suppressHydrationWarning={true}>{t16}{children}</main>;
    $[27] = children;
    $[28] = t16;
    $[29] = t2;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  return t17;
};